/**
 * True when the PWA is running in installed/standalone mode (i.e. the user
 * launched it from the home screen icon, not via a browser tab).
 *
 * - iOS exposes a non-standard `navigator.standalone` boolean.
 * - Standards-track browsers (Chrome/Edge/Firefox) expose
 *   `window.matchMedia('(display-mode: standalone)').matches`.
 */
export function isStandalone(): boolean {
  if (typeof navigator === 'undefined') return false;
  const navStandalone = (navigator as { standalone?: boolean }).standalone;
  if (navStandalone === true) return true;
  if (typeof window !== 'undefined' &&
      window.matchMedia?.('(display-mode: standalone)').matches) {
    return true;
  }
  return false;
}

/**
 * True when the user agent is iOS WebKit (Safari, in-app browsers, Chrome iOS,
 * etc — they all share the same WebKit engine on iOS).
 *
 * Preserved verbatim from the previous home in apps/driver/src/lib/firebase.ts
 * (commit history: predates 2026-06-01). Consolidating here so the reCAPTCHA
 * fallback flow and the new InstallCard share one canonical detector.
 *
 * iPadOS 13+ reports as `Macintosh` in the UA; touch points disambiguate.
 */
export function isIosWebKit(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const isIpad = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  return /iPad|iPhone|iPod/.test(ua) || isIpad;
}
